module.exports = __webpack_public_path__ + "img/LIDO_ROCKY_HORROR_15v2.4dab5188.jpg";